import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getDatabase } from '../../actions/infrastructures';
import { Settings, Activity, Database, Server, GitBranch, Globe, Layers, Code } from 'lucide-react';
import General from "./Tabs/General";
import Metrics from './Tabs/Metrics';
import Endpoint from './Tabs/Endpoint';
import Replicas from './Tabs/Replicas';
import TopSQLQueries from './Tabs/TopSQLQueries';
import axios from 'axios';

const DatabasePage = () => {
  const { projectId, databaseId } = useParams();
  const [activeTab, setActiveTab] = useState('general');
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDatabase(projectId, databaseId));
  }, [dispatch, projectId, databaseId]);

  const databaseInfo = useSelector(state => state?.infrastructures?.currentDatabase);

  const tabs = [
    { id: 'general', name: 'General', icon: Settings },
    { id: 'metrics', name: 'Metrics', icon: Activity },
    { id: 'endpoint', name: 'Connection', icon: Globe },
    { id: 'replicas', name: 'Read Replicas', icon: Layers },
    { id: 'sql', name: 'SQL Queries', icon: Code },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'general':
        return <General databaseInfo={databaseInfo} />;
      case 'metrics':
        return <Metrics databaseInfo={databaseInfo} />;
      case 'endpoint':
        return <Endpoint databaseInfo={databaseInfo} />;
      case 'replicas':
        return <Replicas databaseInfo={databaseInfo} />;
      case 'sql':
        return <TopSQLQueries databaseInfo={databaseInfo} />;
      default:
        return null;
    }
  };

  if (!databaseInfo) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600" />
      </div>
    );
  }

  return (
    <div className="min-h-screen p-8 bg-gradient-to-b from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900 font-display mb-2">
            {databaseInfo?.databaseName}
          </h1>
          <div className="flex items-center space-x-2 text-sm text-gray-500">
            
          </div>
        </div>

        {/* Tabs */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-8">
          <div className="border-b border-gray-200">
            <nav className="flex space-x-8 px-6" aria-label="Tabs">
              {tabs?.map((tab) => {
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`
                      py-4 px-1 border-b-2 font-medium text-sm flex items-center space-x-2
                      ${activeTab === tab.id
                        ? 'border-indigo-600 text-indigo-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }
                    `}
                  >
                    <Icon className="w-5 h-5" />
                    <span>{tab.name}</span>
                  </button>
                );
              })}
            </nav>
          </div>
        </div>

        {/* Tab Content */}
        <div className="space-y-6">
          {renderTabContent()}
        </div>
      </div>
    </div>
  );
};

export default DatabasePage;